// Bu Fn sadece Assignment File içinde kulanılıyor, proje buyuk oldugu için karmaşıklık olmamması adına mixin kullanılmadı,
// ihtiyac duruunda daha üst komponnetlere taşınabilir

export function createQrCodeForEveryClassroomEducation({result, assignmentId}) {
    const classroomContents = result.contents_programs.filter(
        // sadece file_category_id === 14 olanlar için QR kodu üret
        //  (education) => education.content_category_id === 3 ekle de content_category_id, guncellede file_category_id, 2 side aynı degerre sahip
        (education) => education.file_category_id ? education.file_category_id === 14 : education.content_category_id === 3
    );

    if (classroomContents.length > 0) {
        return classroomContents.map((content) => {
            return {
                code: `${window.location.origin}/#/assignments/${assignmentId}/classroom-education?lesson=${content.id}`,
                title: content.title,
                pivot: content.pivot
            };
        });
    }

    return [];
}
